import React, { useState, useEffect } from "react";
import api from "../../api";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import ReactSelect from "react-select";
import {
  Paper,
  Grid,
  Table,
  TableHead,
  TableRow,
  TableContainer,
  TableBody,
  TableCell,
  Button,
  Dialog,
  DialogContent,
  TextField,
  IconButton,
} from "@material-ui/core";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import ConfirmDialog from "../common/confirmDialog/ConfirmDialog";
import { HexColorPicker } from "react-colorful";
import utils from "../../utils/utils";
import Alert from "@material-ui/lab/Alert";
import Pagination from "@material-ui/lab/Pagination";
import Tooltip from "@material-ui/core/Tooltip";
import SearchIcon from "@material-ui/icons/Search";
import CategoriesView from "./CategoriesView";
import "../categories/Categories.scss";

export default function CategoriesList({
  setIsLoading,
  setDataToast,
  dataTable,
  classes,
  shortError,
  reloadData,
  paginationData,
}) {
  const [companiesListEdit, setCompaniesListEdit] = useState([]);
  const [viewDialog, setViewDialog] = useState(false);
  const [defaultValues, setDefaultValues] = useState({
    id: undefined,
    name: "",
    color: "",
    urlImage: "",
    companyId: "",
    externalCategory: "",
  });
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    id: undefined,
  });
  const [openEdit, setOpenEdit] = React.useState(false);
  const [viewData, setViewData] = useState();

  const handleClickEdit = (id) => {
    setDefaultValues({
      id: undefined,
      name: "",
      color: "",
      urlImage: "",
      companyId: "",
      externalCategory: "",
    });
    getCategories(id);
  };

  const getCategories = (id) => {
    setIsLoading(true);
    api
      .getCategoryById(id)
      .then((res) => {
        setDefaultValues({
          id: res.data.id,
          name: res.data.nombre,
          color: res.data.color,
          companyId: res.data.companiaId,
          urlImage: res.data.imagenUrl,
          externalCategory: res.data.nombreCategoriaExterna,
        });
        setViewData(true);
        setIsLoading(false);
      })
      .catch((err) => {
        setViewData(false);
        shortError("Ocurrió un error.");
        setIsLoading(false);
      });
  };

  const handleImputChange = (e) => {
    setDefaultValues({ ...defaultValues, name: e.target.value });
  };
  const handleInputChangeColor = (e) => {
    setDefaultValues({ ...defaultValues, color: e });
  };
  const handleInputChangeCompanyId = (e) => {
    setDefaultValues({ ...defaultValues, companyId: e.key });
  };
  const handleDeleteImage = (e) => {
    setDefaultValues({ ...defaultValues, urlImage: undefined });
  };
  const handleImputChangeExternalCategory = (e) => {
    setDefaultValues({ ...defaultValues, externalCategory: e.target.value });
  };

  function uploadImage(e) {
    let files = e.target.files;
    if (files) {
      setIsLoading(true);

      let data = new FormData();
      let file = files.item(0);
      if (
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png"
      ) {
        data.append("files", files.item(0));

        api
          .uploadFile(data)
          .then((res) => {
            let file = res.data.files[0].url;
            setDefaultValues({ ...defaultValues, urlImage: file });
            setIsLoading(false);
          })
          .catch(() => {
            setIsLoading(false);
            shortError("Ocurrió un error al subir el archivo.");
          });
      } else {
        setIsLoading(false);
        shortError("Solo se permite una imagen de formato JPG, JPEG o PNG.");
      }
    }
  }

  const ConfirmEditCategory = () => {
    setIsLoading(true);
    if (checkValueCreateCategories()) {
      var body = {
        nombre: defaultValues.name.trim(),
        color: defaultValues.color,
        companiaId: parseInt(defaultValues.companyId),
        imagenUrl: defaultValues.urlImage,
        categoriaExterna: defaultValues.externalCategory,
      };
      api
        .putCategory(defaultValues.id, body)
        .then((res) => {
          setIsLoading(false);
          setDataToast({
            active: true,
            message: "Categoría editada correctamente.",
            type: "success",
          });
          setOpenEdit(false);
          reloadData(1, true);
        })

        .catch((err) => {
          setIsLoading(false);
          setDataToast({
            active: true,
            message: err.response.data.errores ?? "Ocurrió un error.",
            type: "error",
          });
        });
    } else if (!defaultValues.name.trim()) {
      shortError("Debe ingresar un Nombre");
    } else if (!defaultValues.color) {
      shortError("Debe ingresar un Color");
    } else if (!defaultValues.companyId) {
      shortError("Debe seleccionar una compañía");
    } else if (!defaultValues.urlImage) {
      shortError("Debe subir una imagen");
    } else if (!defaultValues.externalCategory) {
      shortError("Debe ingresar una categoría externa");
    }
    setIsLoading(false);
  };
  const preDeleteCategory = (id) => {
    setDeleteDialog({ open: true, id: id });
  };

  const deleteCategory = (id) => {
    setDeleteDialog({ ...deleteDialog, open: false });
    setIsLoading(true);
    api
      .deleteCategory(id)
      .then((res) => {
        reloadData(1, true);
        setIsLoading(false);
        utils.alertSuccess("Categoría eliminada correctamente.");
      })
      .catch((err) => {
        setIsLoading(false);
        if (err.response.data.errores) {
          utils.alertError(err.response.data.errores[0]);
        } else {
          shortError("Ocurrió un error");
        }
      });
  };

  const changePage = (event, value) => {
    reloadData(value, false);
  };

  const checkValueCreateCategories = () => {
    let response = false;

    if (
      defaultValues.name.trim() &&
      defaultValues.color &&
      defaultValues.companyId &&
      defaultValues.urlImage &&
      defaultValues.externalCategory
    ) {
      response = true;
    }

    return response;
  };

  function viewCategory(id) {
    setIsLoading(true);
    let selectCompanies;
    let category;
    Promise.all([
      api.getCompanies().then((res) => {
        selectCompanies = utils.setDataInSearchList(res.data);
      }),
      api.getCategoryById(id).then((res) => {
        category = res.data;
      }),
    ])
      .then(() => {
        setViewData({
          id: category.id,
          name: category.nombre,
          color: category.color,
          companyId: category.companiaId,
          urlImage: category.imagenUrl,
          company: selectCompanies.filter(
            (option) => option.key === category.companiaId
          ),
          externalCategory: category.nombreCategoriaExterna,
        });
        setIsLoading(false);
        setViewDialog(true);
      })
      .catch((err) => {
        setIsLoading(false);
        shortError("Ocurrió un error");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    setIsLoading(true);
    api
      .getCompanies()
      .then((res) => {
        setCompaniesListEdit(utils.setDataInSearchList(res.data));
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        shortError("Ocurrió un error");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <>
      {dataTable && dataTable.length > 0 && (
        <Paper className="c-mt-20 c-grid-results" elevation={3}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TableContainer>
                <Table className="c-table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell className="c-w-10">Nombre</TableCell>
                      <TableCell className="c-w-10">Compañía</TableCell>
                      <TableCell className="c-w-10">
                        Categoría Externa
                      </TableCell>
                      <TableCell className="c-w-20">Opciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataTable.map(
                      ({ id, name, color, company, externalCategory }) => (
                        <TableRow key={id}>
                          <TableCell className="c-w-10">{name}</TableCell>
                          <TableCell className="c-w-10">{company}</TableCell>
                          <TableCell className="c-w-10">
                            {externalCategory}
                          </TableCell>
                          <TableCell className="c-w-10">
                            <Tooltip title="Ver" arrow>
                              <IconButton
                                className="c-grid-btn-info button-grid"
                                onClick={() => viewCategory(id)}
                              >
                                <SearchIcon />
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Editar" arrow>
                              <IconButton
                                className="c-grid-btn-edit button-grid"
                                onClick={() => {
                                  handleClickEdit(id);
                                  setOpenEdit(true);
                                }}
                              >
                                <CreateIcon />
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Dar de baja" arrow>
                              <IconButton
                                className="c-grid-btn-cancel button-grid"
                                onClick={() => preDeleteCategory(id)}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      )
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid
              item
              xs={12}
              container
              direction="column"
              alignItems="center"
              justify="center"
            >
              <Pagination
                className="c-pagination"
                onChange={changePage}
                page={paginationData.currentPage}
                count={paginationData.count > 1 ? paginationData.count : 0}
                shape="rounded"
              />
            </Grid>
          </Grid>
        </Paper>
      )}

      {dataTable && dataTable.length === 0 && (
        <Paper className="c-mt-20" elevation={3}>
          <Grid container spacing={1}>
            <Grid item xs={12} className="c-text-center">
              <h5>No se encontraron resultados.</h5>
            </Grid>
          </Grid>
        </Paper>
      )}

      {deleteDialog !== undefined && (
        <ConfirmDialog
          open={deleteDialog.open}
          message={"¿Desea eliminar la Categoría?"}
          cancelAction={() => setDeleteDialog(false)}
          confirmAction={() => deleteCategory(deleteDialog.id)}
        />
      )}

      {viewDialog !== false && (
        <Dialog
          open={viewDialog}
          onClose={() => setViewDialog(false)}
          fullWidth={true}
          classes={{
            paperFullWidth: classes.paperFullWidth,
          }}
        >
          {viewData !== undefined && (
            <CategoriesView
              data={viewData}
              handleClose={() => setViewDialog(false)}
            />
          )}
        </Dialog>
      )}

      {viewData && (
        <Dialog
          open={openEdit}
          onClose={() => setOpenEdit(false)}
          aria-labelledby="form-dialog-title"
          fullWidth={true}
          classes={{
            paperFullWidth: classes.paperFullWidth,
          }}
        >
          <DialogTitle id="form-dialog-title">Editar Categoría</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Nombre"
              type="text"
              name="nombre"
              value={defaultValues.name}
              onChange={handleImputChange}
              fullWidth
            />
          </DialogContent>
          <DialogContent
            classes={{
              root: classes.dialogContentRoot,
            }}
          >
            <section className="small example">
              <HexColorPicker
                color={defaultValues.color}
                onChange={handleInputChangeColor}
              />
              <div
                className="value"
                style={{ borderLeftColor: defaultValues.color }}
              >
                Color: {defaultValues.color}
              </div>
            </section>
          </DialogContent>
          <DialogContent
            classes={{
              root: classes.dialogContentRoot,
            }}
            style={{ maxWidth: 300 }}
          >
            <ReactSelect
              styles={{ maxWidth: 350 }}
              placeholder="Asociar compañía..."
              value={companiesListEdit.filter(
                (option) => option.key === defaultValues.companyId
              )}
              options={companiesListEdit}
              onChange={handleInputChangeCompanyId}
            />
          </DialogContent>
          <DialogContent>
            {defaultValues.urlImage && (
              <Alert severity="success">
                Imagen subida{" "}
                <a href={defaultValues.urlImage} target="_blank">
                  aqui.
                </a>
              </Alert>
            )}
            <input
              accept="image/*"
              className="c-none"
              id="signature"
              type="file"
              accept="application/jpg"
              onChange={uploadImage}
            />
            <label htmlFor="signature">
              <Button
                className="c-btn-info c-mb-5 c-mt-10"
                variant="contained"
                component="span"
              >
                Subir Imagen
              </Button>
            </label>
            {defaultValues.urlImage && (
              <Tooltip title="Eliminar imagen" arrow>
                <IconButton
                  className="c-grid-btn-cancel button-grid"
                  onClick={handleDeleteImage}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            )}
          </DialogContent>
          <DialogContent>
            <TextField
              margin="dense"
              id="externalCategory"
              label="Categoría Externa"
              type="text"
              name="externalCategory"
              value={defaultValues.externalCategory}
              onChange={handleImputChangeExternalCategory}
              fullWidth
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpenEdit(false)} className="c-btn-cancel">
              Cancelar
            </Button>

            <Button
              onClick={() => ConfirmEditCategory()}
              className="c-btn-success"
            >
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
